import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from './../../config/page-settings.js';
import InvestorList from './InvestorList';

const Investors = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  const addUser = () => {
    props.history.push('/investor/create');
  };

  const onViewPriority = () => {
    props.history.push('/investors/priority');
  };

  return (
    <div>
      <h1 className="page-header">
        Investors{' '}
        <button onClick={addUser} className="btn btn-primary btn-icon btn-circle btn-md ml-2">
          <i className="fa fa-plus"></i>
        </button>
        <button className="btn btn-secondary btn-icon btn-circle btn-md ml-2">
          <i className="fa fa-download"></i>
        </button>
        <button className="btn btn-info btn-icon btn-circle btn-md ml-2" onClick={onViewPriority}>
          <i className="fa fa-wheelchair"></i>
        </button>
      </h1>
      <InvestorList />
    </div>
  );
};

export default withRouter(Investors);
